import { createSelector } from 'reselect'
import { IStore } from '../../index'
import { getUserSummary } from '../../userObject/selectors/settings'

export function getToggleSummary(state: IStore) {
  return state.bookingCalendar.summary
}

export const getSummary = createSelector(
  [getToggleSummary, getUserSummary],
  (summary, userSummary) => {
    const isSummary = userSummary
      ? Object.values(userSummary).some(v => v === true)
      : false
    if (summary === null && isSummary) {
      return isSummary
    } else if (typeof summary === 'boolean') {
      return summary && Object.values(userSummary).some(v => v === true)
    } else {
      return false
    }
  },
)
